module.exports = __webpack_public_path__ + "static/media/man_and_guitar.766a94ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/main-page/man_and_guitar.svg
// module id = 29
// module chunks = 0